import React, { useContext, useEffect } from "react";
import FttcHourStore from "../../../app/stores/fttchourStore";
import * as XLSX from "xlsx";
import { RouteComponentProps } from "react-router";
import { Button, Container, Icon, Table } from "semantic-ui-react";
import { observer } from 'mobx-react-lite';

const FttcHourCreateForm: React.FC<RouteComponentProps> = ({ history }) => {
  const fttchourStore = useContext(FttcHourStore);
  const {
    createFttcHour,
    submitting,
    importFttcHours,
    fttchourList,
    clearFttcHour,
  } = fttchourStore;

  useEffect(() => {
    return () => {
      clearFttcHour();
    };
  }, []);

  const handleSubmit = () => {
    createFttcHour(fttchourList).then(() =>
      history.push(`/financemanagement/fttchour`)
    );
  };

  const readExcel = (file: any) => {
    const promise = new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsBinaryString(file[0]);

      fileReader.onload = () => {
        const bufferArray = fileReader.result;
        const wb = XLSX.read(bufferArray, { type: "binary" });
        const wsname = wb.SheetNames[0];
        const ws = wb.Sheets[wsname];
        const data = XLSX.utils.sheet_to_json(ws);

        resolve(data);
      };

      fileReader.onerror = (error) => {
        reject(error);
      };
    });

    promise
      .then((data) => {
        importFttcHours(data);
      })
      .catch((error) => console.log(error));
  };

  var i = 0;
  return (
    <Container fluid>
      <Button as="label" htmlFor="file" type="button" color="blue" size="small">
        <Icon name="file excel" />
        Import
      </Button>
      <input
        type="file"
        id="file"
        accept=".xlsx, .xls, .csv"
        hidden
        onChange={(e) => {
          const file = e.target.files;
          readExcel(file);
        }}
      />
      <Button
        loading={submitting}
        floated="right"
        color="green"
        onClick={handleSubmit}
        content="Submit"
      />
      <Table celled>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>No.</Table.HeaderCell>
            <Table.HeaderCell>Financial Year</Table.HeaderCell>
            <Table.HeaderCell>Pay Run</Table.HeaderCell>
            <Table.HeaderCell>Work Order</Table.HeaderCell>
            <Table.HeaderCell>SOR</Table.HeaderCell>
            <Table.HeaderCell>Work Order Lines Description</Table.HeaderCell>
            <Table.HeaderCell>Amount</Table.HeaderCell>
            <Table.HeaderCell>Technician</Table.HeaderCell>
            <Table.HeaderCell>Start Date</Table.HeaderCell>
            <Table.HeaderCell>Comment</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {fttchourList.map((fttchour) => {
            i = i + 1;
            return (
              <Table.Row key={fttchour.id}>
                <Table.Cell>{i}</Table.Cell>
                <Table.Cell>{fttchour.financialYear}</Table.Cell>
                <Table.Cell>{fttchour.payRun}</Table.Cell>
                <Table.Cell>{fttchour.workOrder}</Table.Cell>
                <Table.Cell>{fttchour.sorId}</Table.Cell>
                <Table.Cell>{fttchour.description}</Table.Cell>
                <Table.Cell>{fttchour.amount}</Table.Cell>
                <Table.Cell>{fttchour.tech}</Table.Cell>
                <Table.Cell>
                  {fttchour.startDate.substr(8, 2) +
                    "/" +
                    fttchour.startDate.substr(5, 2) +
                    "/" +
                    fttchour.startDate.substr(0, 4)}
                </Table.Cell>
                <Table.Cell>{fttchour.comment}</Table.Cell>
              </Table.Row>
            );
          })}
        </Table.Body>
      </Table>
    </Container>
  );
};

export default observer(FttcHourCreateForm);
